// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"IconButton_iconButton__ImNvs","isSingleIcon":"IconButton_isSingleIcon__Je8is"};